<a [href]="link" target="_blank" rel="noopener" [ngClass]="class">{{ text }}</a>
